import { TimeSignal } from 'graphql/types';
import { GroupDurationStrategy } from './GroupDurationCalculator';

export class SumDurationStrategy implements GroupDurationStrategy {
  constructor(private isTIWebGroupViewEnabled: boolean) {}

  calculate(notes: TimeSignal[]): number {
    return notes.reduce((acc: number, note: TimeSignal) => {
      if ((this.isTIWebGroupViewEnabled && note.excluded) || !note.duration) {
        return acc;
      }

      return note.duration + acc;
    }, 0);
  }
}
